import { useTranslation } from 'react-i18next'

import { REQUEST_PROFILE_CHANGE_TYPE } from '../../../../../constants/request'
import { useNotification } from '../../../../../hooks'
import { toRequestSelectItem } from '../../../../Request'
import {
  createTask,
  getTaskCreationSuccessNotificationProps,
  TASK_FORM_INITIAL_VALUES,
  TASK_FORM_MANAGER_FIELD_NAME,
  TASK_FORM_PHASE_FIELD_NAME,
  TASK_FORM_SERVICE_REQUEST_FIELD_NAME,
  TaskFormModal,
} from '../../../../Task'
import { toUserSelectItem } from '../../../../User'
import { useRequestProfileContext } from '../../../RequestProfile.hooks'

export function useRequestProfileCreateActivityAction() {
  const { t } = useTranslation()

  const { handleAddSuccessNotification } = useNotification()

  const {
    handleCloseModal,
    handleReloadAfterChange,
    phases,
    requestData,
    setModal,
  } = useRequestProfileContext()

  function handleActivitySuccess(data) {
    handleCloseModal()
    handleAddSuccessNotification(
      getTaskCreationSuccessNotificationProps({ ...data, t })
    )
    handleReloadAfterChange(REQUEST_PROFILE_CHANGE_TYPE.activities)
  }

  function handleClickCreateActivity() {
    const initialManager =
      requestData?.assignees?.length === 1 ? requestData?.assignees?.[0] : null

    const initialPhase = phases?.length === 1 ? phases[0].id : null

    setModal(
      <TaskFormModal
        fieldsProps={{
          hideServiceRequest: true,
          phases,
        }}
        initialValues={{
          ...TASK_FORM_INITIAL_VALUES,
          [TASK_FORM_MANAGER_FIELD_NAME]: initialManager
            ? toUserSelectItem(initialManager)
            : null,
          [TASK_FORM_PHASE_FIELD_NAME]: initialPhase,
          [TASK_FORM_SERVICE_REQUEST_FIELD_NAME]: requestData
            ? toRequestSelectItem(requestData)
            : null,
        }}
        onClose={handleCloseModal}
        onSubmit={createTask}
        onSuccess={handleActivitySuccess}
      />
    )
  }

  return { handleClickCreateActivity }
}
